import action from "../helpers/rest-client";
import {
  EnrollmentValoration,
  NewEnrollmentOutDto,
} from "../types/enrollment.dto";

export class ErrorEnrollment extends Error { }

class Enrollment {
  public new(payload: NewEnrollmentOutDto) {
    console.log(payload);
    return action
      .Post({
        url: `/enrollment`,
        body: {
          course_id: payload.idCourse,
        },
      })
      .then((response) => {
        return { response: response.success.result };
      })
      .catch((error) => {
        return { error };
      });
  }

  public getAll(payload) {
    const { filters } = payload;
    const perpage = payload?.pagination?.limit || 10;
    const page = payload?.pagination?.page;
    const query = new URLSearchParams(filters).toString();

    return action
      .Get({
        url: `/course/userCourses?${query}&page=${page}&perpage=${perpage}`,
      })
      .then((response) => {
        return { response: response.success.result.rows };
      })
      .catch((error) => {
        return { error };
      });
  }

  public update({ idEnrollment, body }) {
    return action
      .Patch({
        url: `/enrollment/${idEnrollment}`,
        body,
      })
      .then((response) => {
        return { response };
      })
      .catch((error) => {
        return { error };
      });
  }

  public getOne({ idEnrollment, body }) {
    return action
      .Get({
        url: `/enrollment/${idEnrollment}`,
        body,
      })
      .then((response) => {
        return { response };
      })
      .catch((error) => {
        return { error };
      });
  }

  public enrollmentValoration(body: EnrollmentValoration) {
    return action
      .Post({
        url: `/enrollment/feedback`,
        body,
      })
      .then((response) => {
        return { response };
      })
      .catch((error) => {
        return { error };
      });
  }
}

const enrollment = new Enrollment();
export default enrollment;
